import React, { useEffect } from "react";
import $ from "jquery";
export default function ToTop() {
  useEffect(() => {
    $(window).on("scroll", function () {
      $(this).scrollTop() > 300
        ? $(".back-to-top").addClass("showbtn")
        : $(".back-to-top").removeClass("showbtn");
    });
  }, []);
  const backToTop = () => {
    return (
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        600
      ),
      !1
    );
  };

  return (
    <>
      <div className="overlay nav-toggle-icon"></div>

      <div className="back-to-top" onClick={backToTop}>
        <i className="bi bi-arrow-up top-arrow"></i>
      </div>
    </>
  );
}
